import React, { useState, useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { Tooltip } from '@mui/material'

const emailStatusColors = {
  DELIVERED: '#059669',
  WAITING: '#6b7280',
  FAILED: '#dc2626'
}

const emailStatuses = ['DELIVERED', 'WAITING', 'FAILED']

const EmailStatusPercentageBar = ({ emailStats }) => {
  const { t, i18n } = useTranslation()

  const [processedStatuses, setProcessedStatuses] = useState([])

  const emailStatValuesArr = Object.values(emailStats || {})
  const totalEmailCount = emailStatValuesArr.reduce((a, b) => a + b, 0)

  const getPercent = (val) => {
    const percent = val * 100 / totalEmailCount

    return percent % 1 === 0 ? percent : percent.toFixed(1)
  }

  useEffect(() => {
    const allStatusObjArr = []

    emailStatuses.forEach((item) => {
      if (emailStats?.[item]) {
        allStatusObjArr.push({
          label: t(`mailTemplate.campaigns.emailReport.${item}`),
          color: emailStatusColors[item],
          value: getPercent(emailStats[item])
        })
      }
    })

    setProcessedStatuses(allStatusObjArr)
  }, [emailStats, t])

  return (
    <div className="w-full px-1">
      <div className="flex justify-between items-end mb-1.5">
        <span className="text-[10px] uppercase tracking-wider font-semibold text-gray-400">{t('mailTemplate.campaigns.progress.label') || 'Progress'}</span>
        <span className="text-xs font-bold text-gray-700">{i18n.language === 'tr'
          ? `%${Math.round(processedStatuses.reduce((acc, curr) => acc + parseFloat(curr.value), 0)) || 0}`
          : `${Math.round(processedStatuses.reduce((acc, curr) => acc + parseFloat(curr.value), 0)) || 0}%`}</span>
      </div>
      <div className="h-1 w-full bg-gray-100 rounded-full overflow-hidden flex">
        {processedStatuses.length > 0
          ? (processedStatuses.map((item, index) => (
              <Tooltip key={index} title={`${item.label} (%${item.value})`} arrow placement="top">
                <div
                  style={{ width: `${item.value}%`, backgroundColor: item.color }}
                  className="h-full transition-all duration-500 ease-out first:rounded-l-full last:rounded-r-full cursor-help"
                />
              </Tooltip>
            ))
            )
          : (
            <div className="h-full w-full bg-gray-100"/>
            )}
      </div>
    </div>
  )
}

export default EmailStatusPercentageBar
